<template>
<div>
	<div class="label-group">
		<slot></slot>
		<button class="button-group" :class="showPassword ? 'hide' : 'show'" type="button" @click="showPassword = !showPassword">
			{{ showPassword ? hideLabel : showLabel }}
			<svg v-if="showPassword" viewBox="0 0 24 24"><use xlink:href='#eye-closed'></use></svg>
			<svg v-else viewBox="0 0 24 24"><use xlink:href='#eye'></use></svg>
		</button>
	</div>
	<input :required="required" :placeholder="placeholder" :id="id" :name="id" :type="showPassword ? 'text' : 'password'" v-model="generatedPassword">
	<generate-password v-show="showGenerator" v-on:generated-password="onGeneratePassword($event)">{{
		passwordGeneratorLabel }}</generate-password>
</div>
</template>

<script>
    import generatePassword from './generatePassword.vue';

    export default {
	props: {
		id: {
			type: String
		},
		placeholder: {
			type: String
		},
        required: {
            type: Boolean
        },
        hideLabel: {
            type: String,
            default: 'Cacher'
        },
        showLabel: {
            type: String,
            default: 'Montrer'
        },
		passwordGeneratorLabel: {
			type: String,
			default: 'Générer un mot de passe'
		},
		showGenerator: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			generatedPassword: '',
			showPassword: false
		}
	},
	components: {
		'generate-password': generatePassword
	},
	methods: {
		onGeneratePassword(generatedPassword) {
			this.generatedPassword = generatedPassword;
			this.showPassword = true;
		}
	}
}
</script>
